import { segmentCount } from '@wix/motion-edm-autogen-common';
import { every, isArray, isString, some } from 'lodash';
import { transformations } from '../common';
const { OMIT_SOURCE_PROPERTY_NAME, FIELDS_TO_OMIT_PROPERTY_NAME } = transformations;
const validationError = (description, value, parentPath = null) => ({
    invalidValue: value,
    description,
    parentPath,
});
const validateOmitTransformation = ({ source, fieldsToOmit, validateSource, parentPath = null, }) => {
    const validationErrors = [];
    const currentPath = parentPath ? [parentPath] : [];
    const omitSourcePropertyPath = [
        ...currentPath,
        OMIT_SOURCE_PROPERTY_NAME,
    ].join('.');
    validationErrors.push(...validateSource(source).validationErrors.map((sourceValidationError) => ({
        ...sourceValidationError,
        parentPath: omitSourcePropertyPath,
    })));
    const fieldsToOmitPropertyPath = [
        ...currentPath,
        FIELDS_TO_OMIT_PROPERTY_NAME,
    ].join('.');
    if (!isArray(fieldsToOmit) || !every(fieldsToOmit, isString)) {
        validationErrors.push(validationError('must be an array of strings', fieldsToOmit, fieldsToOmitPropertyPath));
        return validationErrors;
    }
    if (some(fieldsToOmit, (omitPathSegment) => segmentCount(omitPathSegment) > 1)) {
        validationErrors.push(validationError('must contain non-nested paths only', fieldsToOmit, fieldsToOmitPropertyPath));
    }
    return validationErrors;
};
export { validateOmitTransformation, validationError };
//# sourceMappingURL=common.js.map